"use client";
import React, { useState, useEffect } from "react";
import {
  Conversation,
  RequestConversationCreate,
  RequestConversationUpdate,
} from "@/app/models/interfaceConversation";
import InputChat from "../Elements/Core/InputChat";
import { Action } from "@/app/constants/enums";
import ButtonChat from "../Elements/Core/ButtonChat";
import {
  createConversation,
  updateConversation,
} from "@/app/services/conversationService";
import { useUser } from "@/app/context/UserContext";
import { getCookie } from "@/app/helpers/cookies";
import { getcurrentUser } from "@/app/helpers/functions";

interface Props { 
  onClose: () => void;
  onUpdateList: () => void;
  editingConv: any | null;
}

const ConversationForm: React.FC<Props> = ({ 
  onClose,
  onUpdateList,
  editingConv,
}) => {
  const { user,userProject, currentConversation,setCurrentConversation,setUser,accessType  } = useUser();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<{ name?: string }>({});
  const [form, setForm] = useState<RequestConversationCreate>({
    name: "",
    description: "",
    user_id: getcurrentUser(accessType, userProject, user),
    project_id: userProject?.project?.id ?? "",
    company_code: userProject?.project?.company_code ?? "",
    company_name: userProject?.project?.company_name??"",
  });

  useEffect(() => {
    if (editingConv) {
      setForm({
        name: editingConv.name,
        description: editingConv.description,
        user_id: editingConv.user_id,
        project_id: editingConv.project_id,
        company_code: userProject?.project?.company_code ?? "",
        company_name: userProject?.project?.company_name??"",
        env: userProject?.project?.env ?? "",
      });
    }
  }, [editingConv]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.name?.trim()) {
      setErrors({ name: "El nombre es obligatorio" });
      return;
    }
    setErrors({});
    setLoading(true);
    try {
      let response; 
      if (editingConv) {
        response = await updateConversation(editingConv.conversation_id, form, user, setUser); 
      } else { 
        response = await createConversation(form, user, setUser);
      }
      onUpdateList();
      onClose();
      if(response.data){
        const conversation = response.data as Conversation; 
        setCurrentConversation(conversation)
      }
      
      
    } catch (error) {
        console.error("Error al guardar conversación:", error);
    } finally {
        setLoading(false);
    }
  };
 
  return ( 
     <div className="m-5 
      min-w-[400px] max-w-[600px] 
                      sm:min-w-[600px] sm:max-w-[100%] 
                      md:min-w-[600px] md:max-w-[600px] 
                      lg:min-w-[600px] lg:max-w-[600px]

                      min-h-[200px] max-h-[300px] 
                      sm:min-h-[200px] sm:max-h-[300%s] 
                      md:min-h-[200px] md:max-h-[300px] 
                      lg:min-h-[200px] lg:max-h-[300px]
     ">
      <form onSubmit={(e) => handleSubmit(e)}>
          <h3 className="text-lg font-bold mb-4">
            {editingConv ? "Editar Conversación" : "Nueva Conversación"}
          </h3>
          
          <div className="mb-4">
              <label className="block text-gray-700">Nombre</label> 
              <InputChat
                actionCode={Action.LEFT_CONVERSATION_ADD_NAME} 
                type="text"
                name="name"
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                value={form.name}
                disabled={loading}
                className="border w-full p-2 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700"
                placeholder="Nombre"
                autoComplete="OFF"
              />
              {/*errors.name && <p className="text-red-600 text-sm mt-2">{errors.name}</p>*/}
          </div> 
          <div className="mb-4">
              <label className="block text-gray-700">Descripción</label> 
              <InputChat
                actionCode={Action.LEFT_CONVERSATION_ADD_DESCRIPTION} 
                type="text"
                name="name"
                onChange={(e) => setForm({ ...form, description: e.target.value })}
                value={form.description}
                disabled={loading}
                className="border w-full p-2 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700"
                placeholder="Descripción"
                autoComplete="OFF"
              />
              {errors.name && <p className="text-red-600 text-sm mt-2">{errors.name}</p>}
          </div>  
          <div className="flex items-center justify-end"> 
            <ButtonChat
                actionCode={Action.LEFT_CONVERSATION_ADD_CANCEL}
                type="button"
                onClick={onClose}
                disabled={loading} 
                className="bg-gray-200 hover:bg-gray-300 text-gray-700  py-2 px-4 mr-2 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700"
                >
                Cancelar
              </ButtonChat>
              <ButtonChat
                  actionCode={Action.LEFT_CONVERSATION_ADD_SAVE}
                  type="submit" 
                  disabled={loading}
                  
                  className={`py-2 px-4 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700 
                    ${loading ? "bg-blue-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700 text-white"}`} 
                >
                {loading ? "Guardando..." : editingConv ? "Actualizar" : "Crear"} 
              </ButtonChat>
            </div> 
      </form>
    </div> 
  );
};

export default ConversationForm;
